module.exports = __webpack_public_path__ + "static/media/Terms_Conditions.b5c90de7.svg";